<template>
  <v-btn
    depressed
    block
    class="rounded"
    style="height: 32px !important"
    color="success"
    @click="viewOrderAction(item)"
    :loading="loading"
    :disabled="item.manager_appr_state == '2'"
  >
    <v-icon>{{ item.manager_appr_state == "2" ? icons.mdiMinus : icons.mdiCheckAll }}</v-icon>
  </v-btn>
</template>

<script>
import Vue from "vue";
import { ref } from "vue-demi";
import { postData } from "@utils";
import { useToast } from "vue-toastification/composition";
import { useAppStore } from "@/stores/app";
import store from "@/store";
// Icons
import { mdiCheckAll, mdiMinus } from "@mdi/js";
export default {
  props: {
    item: Object,
  },
  setup(props, { emits }) {
    const toast = useToast();
    const appStore = useAppStore();

    const loading = ref(false);
    const viewOrderAction = (data) => {
      if (store.state.plasiyerCustomer) {
        Vue.swal({
          title: "Emin misin?",
          text: "Müşteri ve Sepetiniz sıfırlanacak",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Onaylıyorum",
        }).then((result) => {
          if (result.isConfirmed) {
            actualizeBasket(data);
          }
        });
      } else {
        actualizeBasket(data);
      }
    };

    const actualizeBasket = (data) => {
      store.commit("PLASIYER_CUSTOMER", null);
      appStore.selectedCustomer = null;
      postData({
        method: "actualizeSubcustBasket",
        uid: data.uid,
        id: data.id,
        basket_id: "SUBCUSTDEF",
      })
        .then((response) => {
          loading.value = true;
          if (response.error) {
            throw new Error(response.msg);
          }
          props.item.order_data.username = props.item.username;
          store.commit("app/TOGGLE_BASKET_DRAWER", true);
          store.commit("app/TOGGLE_BASKET_DRAWER_APPROVAL", props.item.order_data);
        })
        .catch((e) => {
          toast.error(`${e}`, { position: "bottom-center" });
        })
        .finally(() => {
          setTimeout(() => {
            loading.value = false;
          }, 300);
        });
    };
    return {
      viewOrderAction,
      loading,

      // Icons
      icons: {
        mdiCheckAll,
        mdiMinus,
      },
    };
  },
};
</script>

<style></style>
